import PanelWithHeader from './PanelWithHeader';
export default PanelWithHeader;
